var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgCurvedArrow(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 227,
    height: 38,
    viewBox: "0 0 227 38"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M113.91.431c26.27 0 42.558 5.054 61.016 16.07.755.451 2.898 1.764 5.139 3.134l.562.343.694.424a433.346 433.346 0 004.68 2.833c11.308 6.642 19.904 9.447 31.691 9.182L217.395 29a.537.537 0 01.732-.546l8.24 3.26a.537.537 0 01.084.957l-7.552 4.636a.537.537 0 01-.815-.41l-.305-3.484-.133.004c-11.961.257-20.718-2.605-32.152-9.32-2.062-1.212-9.531-5.813-11.08-6.738C156.103 6.431 139.988 1.431 113.91 1.431c-11.565 0-21.215 1.694-30.082 4.969-6.793 2.51-11.853 5.233-21.15 10.957l-1.709 1.052C50.553 24.819 44.858 27.76 37 30.175c-10.206 3.136-21.665 4.071-35.847 2.533a.5.5 0 11.108-.994c14.051 1.524 25.374.6 35.445-2.494 7.755-2.383 13.39-5.294 23.74-11.663l1.707-1.052C71.503 10.75 76.61 8 83.481 5.462c8.98-3.317 18.747-5.031 30.43-5.031z"
  }));
}

export default SvgCurvedArrow;